import axios from "axios";
import { BASE_URL } from "../constants";

const api = axios.create({ baseURL: BASE_URL });

export const installSessionHandler = (onUnauthorized: () => void) => {
  const id = api.interceptors.response.use(
    (response) => response,
    (error) => {
      // Public login/reset failures must not destroy an existing session.
      if (error.response?.status === 401 && error.config?.headers?.Authorization) {
        onUnauthorized();
      }
      return Promise.reject(error);
    }
  );
  return () => api.interceptors.response.eject(id);
};

export default api;
